import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { UUID } from '@/types';
import DashboardFilterRef from '../../util/DashboardFilterRef';

export const dashboardFiltersApi = createApi({
  reducerPath: 'dashboardFiltersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    credentials: 'same-origin',
  }),
  endpoints: (builder) => ({
    getDashboardFilters: builder.query<
      DashboardFilterRef[],
      { datasourceId: UUID; dashboardId: UUID }
    >({
      query: ({ datasourceId, dashboardId }) =>
        `datasources/${datasourceId}/dashboards/${dashboardId}/filters`,
      transformResponse: (response: []) =>
        response.map(DashboardFilterRef.buildFromServer),
    }),
  }),
});

export const { useGetDashboardFiltersQuery } = dashboardFiltersApi;
